import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  Box
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { useOrganization } from '../../../contexts/OrganizationContext';
import { useEnvironment } from '../../../contexts/EnvironmentContext';

const ArchiveConfirmDialog = ({ open, onClose, environment }) => {
  const { selectedOrganization } = useOrganization();
  const { archiveEnvironment, loading } = useEnvironment();
  const [error, setError] = useState(null);

  const handleClose = () => {
    setError(null);
    onClose();
  };

  const handleConfirm = async () => {
    setError(null);

    try {
      await archiveEnvironment(selectedOrganization.id, environment.id);
      handleClose();
    } catch (err) {
      setError(err.message || 'Failed to archive environment');
    }
  };

  if (!environment) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" />
          Archive Environment
        </Box>
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <DialogContentText>
          Are you sure you want to archive the environment <strong>"{environment.name}"</strong>?
        </DialogContentText>

        <Alert severity="info" sx={{ mt: 2 }}>
          Archived environments can be restored later. They will be hidden from the active environments list.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="warning"
          disabled={loading}
        >
          {loading ? 'Archiving...' : 'Archive'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveConfirmDialog;
